module.exports = __webpack_public_path__ + "static/media/dishwashingFrequency.dce9f90b.svg";